import React , { useEffect } from "react";
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {  Formik, Form, Field } from 'formik';
import { Modal, Fade, TextField, Backdrop,Box, CircularProgress, LinearProgress, Typography, Breadcrumbs, Accordion,  ListItemText, Divider, Paper} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AssistantIcon from '@mui/icons-material/Assistant';
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import { useTheme, styled } from "@mui/material/styles";
import Button from "../../components/CustomButtons/Button.jsx";
import {useSelector, useDispatch} from 'react-redux';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableContainer from '@mui/material/TableContainer';
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { mongoUrl } from '../../components/shared/mongoUrl';
import { baseUrl } from '../../components/shared/baseUrl';
import Skeleton from "@mui/material/Skeleton"
import {motion, useCycle, AnimatePresence} from 'framer-motion';
import { upCount, finCount } from "../../reducers/actionCreators";
import { CircularProgressbar,buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";



 const StyledTableCell = styled(TableCell)(({ theme }) => ({
   '&.MuiTableCell-head': {
     backgroundColor: theme.palette.common.black,
     color: theme.palette.common.white,
   },
   '&.MuiTableCell-body': {
     fontSize: 14,
   },
 }));
 
 const StyledTableRow = styled(TableRow)(({ theme }) => ({
   '&:nth-of-type(odd)': {
     backgroundColor: theme.palette.action.hover,
   },
   // hide last border
   '&:last-child td, &:last-child th': {
     border: 0,
   },
 })); 

const StyledcardTitle = styled('div')({
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    textAlign:'center'
});

const StyledcardCategory = styled('div')({
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
});


const StyledModal = styled('div')({
    alignItems: 'center',
    justifyContent: 'center',
    position:'absolute',
    top:'20%',
    left:'10%',
    overflowY:'scroll',
    height:'100%',
    display:'block'
});


const StyledModal1 = styled('div')({
    position: 'relative',
    maxWidth: '700px',
    margin : '0 auto',
    padding: '10px 10px 10px 10px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10
});

const StyledBackdrop = styled('div')({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: "rgba(0,0,0,0.5)",
    zIndex: 10
});



const styles = (theme) =>({
   cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    textAlign:'center'
  },
  fontOswald:{
    fontFamily:"Oswald"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
 
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 1000,

  },
  messageArea: {
    height: '65vh',
    overflowY: 'auto'
  },
  table: {
    minWidth: 500,
  }
});





var task = ['Observe the numbers {24, 12, 15, 20, 49, 29, 13, 18, 25, 30} and identify pairs with maximum sum', 'Observe the pair of numbers and find a way to calculate pairwise maximum',
 'Write a general method to calculate pairs with maximum pairwise sum', 'Write an algorithm to find a pair of numbers with maximum sum',
'Analyse the algorithm to count maximum number of comparisons used by the algorithm and total extra variables defined in the algorithm', 'Write an algorithm to find a pair of numbers with maximum sum ', 'Comparison of the algorithms attempted previously']



function getSteps() {
  return ['Decomposition', 'Pattern Recognition', 'Abstraction', 'Algorithm design', 'Analysis of Algorithm', 'Solution', 'Reflection'];
}

const hintsactivity5 = [
  { step: 'Decomposition'},
  { step: 'Pattern recognition'},
  { step: 'Abstraction' },
  { step: 'Algorithm design'},
  { step: 'Analysis of Algorithm' },
  { step: 'Final solution'},
  { step: 'Reflection'}
]


const firstStep = () =>{

  return(
    <p> First step</p>
  );
};

var cla = {
    "_id":"6006f33eef2c0d65ccbf6601",
    "title": "Class IX",
    "teacherId":"5fe192d970d8c633c005da24"
  }


export default function Fibonacci(props){
    const [module, setmodule] = React.useState('');
    var interval = null
    const [clas, setclas] = React.useState([]);
    const [loading, setloading] = React.useState(true);
    const [loadhint, setloadhint] = React.useState(false);
    const [myCount, setmyCount] = React.useState(10);
    const [myDecoCount, setmyDecoCount] = React.useState(10);
    const [finalCount, setfinalCount] = React.useState(19);
    const [Num, setNum] = React.useState(1);
    const theme = useTheme()
    const classes =styles(theme);
    const [loadsupport, setloadsupport] = React.useState(false);
    const user = useSelector(state => state.user)
    const dispatch = useDispatch();
    const [editorState, seteditorState]= React.useState(EditorState.createEmpty())
    const [loadintro, setloadintro] = React.useState(true);
    const [error, seterror] = React.useState('');
    const [expanded, setExpanded] = React.useState(false);
    const [expanded1, setExpanded1] = React.useState(false); 
    const [addition, setaddition] = React.useState('Individual addition');
    const [termsum, settermsum] = React.useState('0');  
    const [num1, setnum1] = React.useState('0');
    const [num2, setnum2] = React.useState('0');
    const [num3, setnum3] = React.useState('0');
    const [num4, setnum4] = React.useState('0');
    const [num5, setnum5] = React.useState('0');
    const [num6, setnum6] = React.useState('0');
    const [num7, setnum7] = React.useState('0');
    const [num8, setnum8] = React.useState('0');
    const [num9, setnum9] = React.useState('0');
    const [num10, setnum10] = React.useState('0');
    const [num11, setnum11] = React.useState('0');
    const [num12, setnum12] = React.useState('0');
    const [mydata, setmydata] = React.useState('');
    const [totaldata, settotaldata] = React.useState('')
    const [mydeco, setmydeco] = React.useState('');
    const [mytime, setmytime] = React.useState('');
    const [myspace, setmyspace] = React.useState('');
    const [mycomsol, setmycomsol] = React.useState('');
    const [mycomsol1, setmycomsol1] = React.useState('');
    const [mycomsol2, setmycomsol2] = React.useState('');
    const [mycomsol3, setmycomsol3] = React.useState('');
    const [analytics, setanalytics] = React.useState([]);
    const [openBoard, setopenBoard] = React.useState(false);
    const [animation, cycleAnimation] = useCycle("animateOne", "animateTwo");
    const [myModal, setmyModal] = React.useState(true);
    const [myModalTwo, setmyModalTwo] = React.useState(false);
    const [myModalThree, setmyModalThree] = React.useState(false);
    const [ansType, setansType] = React.useState('');
    const [mysum, setmysum] = React.useState('0');
    const [isSubmit, setisSubmit] = React.useState(false);
    //const classes1 = styles1(theme)
    const { classId, sesId } = useParams();


    useEffect(() => {

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const classid = classId;
        //console.log(actId)
        const sessid = sesId;
        console.log(user)
        const loadData=()=>{
          const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };

        try{
          
          setclas(cla)

          axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((response) =>{
            //console.log(response.data)
            settotaldata(response.data)
            
            const totaldata = response.data
            const activity =response.data
            console.log(activity)
            
            //console.log(activity)
            setmydata(activity)

                    
        
            var analyticStatus = [];              
      
                analyticStatus.push({
                    act:'Activity1',
                    score:activity.activity1[0].profileScore
                })
                analyticStatus.push({
                    act:'Activity2',
                    score:activity.activity2[0].profileScore
                })
                analyticStatus.push({
                    act:'Activity3',
                    score:activity.activity3[0].profileScore
                })
                analyticStatus.push({
                    act:'Activity4',
                    score:activity.activity4[0].profileScore
                })
                analyticStatus.push({
                    act:'Activity5',
                    score:activity.activity5[0].profileScore
                })
                analyticStatus.push({
                    act:'Activity6',
                    score:activity.activity6[0].profileScore
                })
                   
                console.log(analyticStatus)
                var arr = totaldata.postTest[0].bebras.split(',')
                var len = arr.length
                var num = Number(arr[len-1])
                var finalscore = Number((num/108)*100).toFixed(2)
                console.log(finalscore)
                setmysum(finalscore)
                ///Update profile directly//////////////////////////////////////////////
               
                setanalytics(analyticStatus)

                try{
                        //getData(sessid)
                  } catch (error) {
                      if (axios.isCancel(error)) {
                        console.log("cancelled");
                      } else {
                        throw error;
                      }
                    }
            
            setloading(false)
            

          })
          .catch((error)=>{
          console.log(error);
          });
        } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }

    };

    loadData();

   
    return() => {source.cancel();
    };


    }, []);

    useEffect(() => {  
      clearInterval(interval);
  
     })


 
  
     const backdrop = {
      visible:{opacity: 1},
      hidden:{opacity: 0}
  }
  
  const modal = {
      hidden:{
        y:"-100vh",
        opacity: 1
      },
      visible:{
        y: "50px",
        opacity:1,
        transition:{ delay: 0.5 }
      },
      exit:{
        y:"500vh",
        opacity: 1,
        transition:{ delay: 1 }
  
      },
    }
  
   
    const commaToText = (txt) =>{
      var mytext = ''
      if(txt!='' && typeof(txt)!=='undefined'){ 
      if(txt.includes(',')==true){
        var newArr = txt.split(',')
        var i=0
        while(newArr[i]!==''&& i<newArr.length && newArr[i]!=='undefined'){
              mytext=mytext+' '+newArr[i]
              i=i+1
          }  
        
         return mytext
      }
      else{
        return txt
      }
    }
    return txt
      
   }
  
  

     const solutionIndex = () =>{
       var len=0
      if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
        len=mydata.decomposition[0].alternateSolution.length
      }
      if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
        len=len+mydata.pattern[0].alternateSolution.length
      }
      if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
        len=len+mydata.abstraction[0].alternateSolution.length
      }
      return len;

     }

    

    const closeModal=()=>{
      setmyModal(!myModal)
    }
    const closeModalTwo=()=>{
      setmyModalTwo(!myModalTwo)
    }
    const closeModalYesThree=()=>{
            
      setmyModalThree(!myModalThree)
      var problemtype = 'medium'/////////set problemtype here
      if(mysum<40){
          problemtype='easy'
      }
      if(mysum>75){
          problemtype='hard'
      }
      //problemtype='easy'
      var num = actId
      var newact = parseInt(num)+1
      var newactivity='activity'+newact
      var newarr = totaldata[newactivity]
      console.log(newarr)

        if(newarr[0].decomposition[0].completed===false){               
            newarr[0].level=problemtype
        }
        
        newarr[0].profileScore=mysum
        newarr[0].decomposition[0].created=new Date()

          const data=
          {
            act: newactivity,
            data: newarr[0]
          }                     
          console.log(data)
      
          axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
          .then((response) => {
              console.log(response.data)
              var act = 'activity'+num
              response.data.currentActivity=newactivity
              response.data[act][0].profileScore=mysum
              console.log('updating profile')
              const mdata=
              {
                profile: response.data
              }                     
              console.log(mdata)
        
              axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, mdata)
              .then((response) => {
            
              history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/${newactivity}${problemtype}`)
        
            })
    })
}


 

    const closeModalNoThree=()=>{
      setmyModalThree(!myModalThree)

    }

    

    const updateCount = (count) =>{
      //console.log(count)
      
      setNum(count)

      if(count<=user.fcount)
      {
        count=count+1
        dispatch(
          upCount(count)
        )
      }
      
    }

    

  const getData = (sessid) =>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      //var num = Num+1
      //setNum(num)
      axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((response) =>{
            //console.log(response.data)
            var n = 'activity'+actId
            const activity =response.data[n]
            settotaldata(response.data)
            //console.log(activity)
            setmydata(activity[0])
           
  
      })
    
  }

  ////////////Code for Stepper////////////////////////////

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    var comp=false; 
      var num = actId
      var newact = parseInt(num)+1
      var newactivity='activity'+newact
      var newarr = totaldata[newactivity]
    if(newarr[0].decomposition[0].proceed===true){                       
        history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/${newactivity}${newarr[0].level}`)
        setisSubmit(false)
        comp=true
    }
   if(comp===false){
     console.log('Not completed step')
    setmyModalThree(!myModalThree)
    setisSubmit(false)
   } 

  };

  const handlePostTest = () =>{

    history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/activityposttest`)
  }


  /////////////////////////////////////////////////////


 

    const ToggleHint = () =>{
      if(loadhint==true){
      setloadhint(false)
      }
      else{
        setloadhint(true)
      }
    } 
    
    const Togglesupport = () =>{
      setloadsupport(!loadsupport)
      
    }



      const handleAccordionChange = (panel) => (event, isExpanded) => {
        setloadintro(false)
        if(panel==='panel8'){
          if(isExpanded===true){
            setmyModalTwo(!myModalTwo)
          }
        }
        setExpanded(isExpanded ? panel : false);
      };

      const handleAccordionChange1 = (panel) => (event, isExpanded) => {
        
        setExpanded1(isExpanded ? panel : false);
      };


      function MyCustomUploadAdapterPlugin(editor){
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
          return new MyUploadAdapter(loader)
        }
      }

      class MyUploadAdapter {
        constructor(props) {
            // CKEditor 5's FileLoader instance.
          this.loader = props;
          // URL where to send files.
          this.url = `${baseUrl}fileupload/files`;
        }
    
        // Starts the upload process.
        upload() {
          return this.loader.file
              .then( file => new Promise( ( resolve, reject ) => {
  
                  const toBase64 = file => new Promise((resolve, reject) => {
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = () => resolve(reader.result);
                      reader.onerror = error => reject(error);
                  });
                  
                  return toBase64(file).then(cFile=>{
                    console.log(file)
                    const data=new FormData();
                    data.append('file', file)   
                    var filename = '';
                  axios.post(`${baseUrl}fileupload/files`, data)
                          .then((response) => {
                              console.log(response.data.file.filename)
                              filename = response.data.file.filename;
                              resolve({ 
                                default: `${baseUrl}fileupload/files/${filename}` 
                              })
                          })
                          .catch((error)=>{
                              reject(`Couldn't upload file: ${ file.name }.`)
                            console.log(error);
                            });
                          })
                  
              } ) );
      }
    
    }

   

      



      const custom_config = {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
    
      }





const history = useNavigate();




    return(
    loading!==true?
      <div>
          <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" to="/student/dashboard">
                Dashboard
              </Link>
              <Link color="inherit" to={`/student/dashboard/viewsession/${classId}`}>
                <Typography color="textPrimary">{clas.title}</Typography>
              </Link>
              {loading!==true?        
              <Link color="inherit" to={`/student/dashboard/viewstudentclass/${clas._id}/session/${totaldata.sessionId}/profile/${sesId}/scenario`}>
                <Typography color="textPrimary"> Scenario </Typography>
              </Link>:null}
              
              <Typography color="textPrimary"> Final Observation</Typography>

            </Breadcrumbs>
            {/* {console.log({...sess}.title)} */}
          </GridItem>
            <GridItem xs={12} sm={12} md={12} >
              <Typography variant="h4" align="center" sx={{fontFamily:"Oswald"}}>
                Final Summary
              </Typography>
            </GridItem>

        <GridItem xs={12} sm={12} md={3} >
         
        </GridItem>
        </GridContainer>

                  <Formik
                    initialValues={{
                    hypothesis: '',
                    }}


                    onSubmit={(values, {setSubmitting}) => {
                     setTimeout(() => {
                        setSubmitting(false);
                   
                    alert(JSON.stringify('Saving...', null, 2));

                        var decompos=''
                        var sum1=parseInt(num1)+parseInt(num2);
                        var sum2=parseInt(num3)+parseInt(num4);
                        var sum3=parseInt(num5)+parseInt(num6);
                        var sum4=parseInt(num7)+parseInt(num8);
                        
                        decompos ='Pairs are-first,second:,(,'+num1+','+num2+',)='+sum1+',first,last:,(,'+num3+','+num4+',)='+sum2+',first,second last:,(,'+num5+','+num6+',)='+sum3+',maximum sum, pair:,(,'+num7+','+num8+',)='+sum4
                        seterror('')
                        mydata.decomposition[0].userText=decompos

                        const data=
                        {
                          act: 'activity5',
                          decomposition: mydata.decomposition
                        }                     
                        console.log(data)

                      axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
                      .then((response) => {
                          console.log(response.data)
                          const activity = response.data.activity5[0]
                          setmydata(activity)
                      })
                     }, 500);
                    }}
                >

          {({submitForm, isSubmitting, touched, errors}) => (
          <Form>
          {loading!==true?

            <GridContainer>
                          
{/**''''''''''''''''''''''''''''''''Code for Hints''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''*/}

            {myModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
                >
                <StyledBackdrop>
                  <motion.div
                    variants={modal} 
                    >
                    <StyledModal1>
                    <h4> Analytics part </h4>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={3}>
                       <img alt='Marine Life' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaCongrats.JPG'} />
                      </GridItem> 
                      <GridItem xs={12} sm={12} md={9}>
                        <h4 sx={{fontFamily:"Oswald"}}><b> Congratulations, You completed the Experiment.!!! </b></h4>
                        <h5 sx={{fontFamily:"Oswald"}}>Check your final score.</h5>
                        <h5 sx={{fontFamily:"Oswald"}}>Observe your previous scores in the 6 activities </h5>
                      </GridItem>
                    </GridContainer>
                    <Button color="success" variant="contained" onClick={closeModal} 
                    title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        OK
                    </Button>
                  </StyledModal1>  
                  </motion.div>
                </StyledBackdrop>
                </motion.div>
            </AnimatePresence>)}

            {hintsactivity5.map((text, index)=>(
              index===activeStep?
              myModalTwo && (
              <AnimatePresence exitBeforeEnter>
                <motion.div 
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                <StyledBackdrop>
                  <motion.div 
                    variants={modal} 
                    >
                     <StyledModal1>
                      <subtitle1> {ansType} </subtitle1>
                      <h5> Current Step: {hintsactivity5[index].step} 
                      {activeStep === 0?mydata.decomposition[0].proceed===true && mydata.decomposition[0].completed===false?' (Submitted)':'':
                      activeStep === 1?mydata.pattern[0].proceed===true && mydata.pattern[0].completed===false?' (Submitted)':'':
                      activeStep === 2?mydata.abstraction[0].proceed===true && mydata.abstraction[0].completed===false?' (Submitted)':'':
                      activeStep === 3?mydata.algorithm[0].proceed===true && mydata.algorithm[0].completed===false?' (Submitted)':'':
                      mydata.analysis[0].proceed===true && mydata.analysis[0].completed===false?' (Submitted)':''}

                      {activeStep === 0?mydata.decomposition[0].completed===true?' (Completed)':'':
                      activeStep === 1?mydata.pattern[0].completed===true?' (Completed)':'':
                      activeStep === 2?mydata.abstraction[0].completed===true?' (Completed)':'':
                      activeStep === 3?mydata.algorithm[0].completed===true?' (Completed)':'':
                      activeStep === 4?mydata.analysis[0].completed===true?' (Completed)':'':null} </h5>
                      {mydata.analysis[0].completed===false?<h5> Your Task: {task[activeStep]}</h5>:null}
                      
                      {(mydata.altStep==='' && mydata.decomposition[0].noOfattempts>1 && (index===0 && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && mydata.decomposition[0].noOfattempts>1 && (index===0 && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Basic Hint: </b> {mydata.decomposition[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && (index===0 && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && (index===0 && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint: </b>  {mydata.decomposition[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced') || (mydata.altStep==='decomposition' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b>  {mydata.decomposition[0].hints[0].advanced}           
                        </GridItem>
                      :null}
                      {(mydata.altStep===''&& (mydata.pattern[0].noOfattempts>1 && index===1 && mydata.pattern[0].levelOfHints==='Basic' || index===1 && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && mydata.pattern[0].noOfattempts>1 && index===1 && mydata.pattern[0].levelOfHints==='Basic' || index===1 && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && mydata.pattern[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Basic Hint: </b>  {mydata.pattern[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && (index===1 && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && (index===1 && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && mydata.pattern[0].levelOfHints==='Advanced'))? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint: </b> {mydata.pattern[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && index===1 && mydata.pattern[0].levelOfHints==='Advanced') || (mydata.altStep==='pattern' && index===1 && mydata.pattern[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b> {mydata.pattern[0].hints[0].advanced}           
                        </GridItem>
                      :null}

                      {(mydata.altStep==='' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b>Basic Hint:</b> {mydata.abstraction[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced') || (mydata.altStep==='abstraction' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint:</b>  {mydata.abstraction[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b> {mydata.abstraction[0].hints[0].advanced}           
                        </GridItem>
                      :null}

                      {(mydata.altStep==='' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Basic Hint: </b> {mydata.algorithm[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint: </b> {mydata.algorithm[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b> {mydata.algorithm[0].hints[0].advanced}           
                        </GridItem>
                      :null}

                      {(mydata.altStep==='' && mydata.analysis[0].noOfattempts>1 && activeStep===4 && mydata.analysis[0].levelOfHints==='Basic' || activeStep===4 && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && mydata.analysis[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Basic Hint: </b> {mydata.analysis[0].hints[0].basic}          
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===4 && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && mydata.analysis[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Intermediate Hint: </b> {mydata.analysis[0].hints[0].intermediate}           
                        </GridItem>
                      :null}
                      {(mydata.altStep==='' && activeStep===4 && mydata.analysis[0].levelOfHints==='Advanced')? 
                        <GridItem xs={12} sm={12} md={12}>
                        <b> Advanced Hint: </b> {mydata.analysis[0].hints[0].advanced}           
                        </GridItem>
                      :null}
                      
                      {activeStep===5 && mydata.analysis[0].completed===false? 
                        <GridItem xs={12} sm={12} md={12}>
                          <b> Your solution </b>
                          <GridItem xs={12} sm={12} md={12}>
                            {mydata.analysis[0].hints[0].basic}          
                          </GridItem>            
                        </GridItem>
                      :null}
                      {activeStep===6 ? 
                        <GridItem xs={12} sm={12} md={12}>
                          <b> Observe the solutions in Your previous attempts tab above consisting of your attempted solutions and all possible solutions. Compare the solutions  </b>            
                        </GridItem>
                      :null}
                      
                      <Button color="success" variant="contained" onClick={closeModalTwo} 
                      title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        OK
                    </Button>
                    </StyledModal1>
                    </motion.div> 
                  </StyledBackdrop> 
                </motion.div>
              </AnimatePresence>)
              :null
            ))
            }

              {myModalThree && (
              <AnimatePresence exitBeforeEnter>
                <motion.div
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <StyledBackdrop>
                  <motion.div
                    variants={modal} 
                    >
                    <StyledModal1>
                      <GridContainer>
                      {setisSubmit(true)}
                        <GridItem xs={12} sm={12} md={3}>
                          <img alt='AskingPanda' width="40" height="100" className="card-img-top" src={baseUrl+'assets/images/pandaPic2.PNG'} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={9} sx={{fontFamily:"Oswald"}}>
                            <h4>  Are you sure you want to go to next activity!!! </h4>
                            <Button color="success" variant="contained" onClick={closeModalYesThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                Yes
                            </Button>
                            <Button color="success" variant="contained" onClick={closeModalNoThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                No
                            </Button>
                          {/* </motion.div> */}
                        </GridItem>
                      </GridContainer>
                      </StyledModal1>
                    </motion.div> 
                    </StyledBackdrop> 
                </motion.div>
              </AnimatePresence>)}
                                <GridItem xs={12} sm={12} md={1}>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={10}>
                                    <Card>
                                        <CardHeader color="info">
                                            <h1 style={classes.cardTitleWhite}> Thank You!! For your Participation</h1>
                                        </CardHeader>
                                        <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={3}>
                                                <img alt='Marine Life' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic3.jpg'} />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={8}>
                                            <blockquote className="blockquote">
                                                <h1> You did fantastic!! Best of Luck for your future!! </h1>
                                                <h1>You can Log out now!!!</h1>
                                            </blockquote>
                                            </GridItem>
                                        </GridContainer>
                                        </CardBody>
                                    </Card>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={1}>
                                </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                                    <TableContainer component={Paper}>
                                            <Table sx={{minWidth: 500}} aria-label="customized table">
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell>Activity</StyledTableCell>
                                                        <StyledTableCell>Score&nbsp;</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                {analytics.map((row) => (
                                                    
                                                    <StyledTableRow key={row.step}>
                                                        <StyledTableCell component="th" scope="row">
                                                            {row.act}
                                                        </StyledTableCell>
                                                        <StyledTableCell>{row.score}</StyledTableCell>
                                                        
                                                    </StyledTableRow>
                                                ))}
                                                </TableBody>
                                            </Table>
                                    </TableContainer>   
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                                    <Card>
                                    <CardHeader color="success">
                                      <StyledcardTitle>
                                        <h4> Final Computational Thinking Score </h4>
                                      </StyledcardTitle>
                                    </CardHeader>
                                        <CardBody>
                                            {['1'].map((text,index)=>{
                                                
                                                return(
                                                
                                                <div style={{ width: "70%" }}>
                                                    <CircularProgressbar
                                                            value={mysum}
                                                            text={`${mysum}%`}
                                                            background
                                                            backgroundPadding={6}
                                                            styles={buildStyles({
                                                            backgroundColor: "#3e98c7",
                                                            textColor: "#fff",
                                                            pathColor: "#fff",
                                                            trailColor: "transparent"
                                                            })}
                                                    /> 
                                                </div>
                                                )                                                
                                               })}                        
                                                                                       
                                        </CardBody>
                                    </Card>
                                </GridItem>
                                
                  

{/* ///////////////////////////////////////////////////////////////////////////////////////// */}

            </GridContainer>:null}
                                                                      

          </Form>
          )}
          </Formik>
          
    </div>:<GridContainer spacing={3}>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box> 
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton variant="circular" width={420} height={300} />    
          </Box> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>  
        <GridItem xs={12} sm={12} md={12}>  
          <Box sx={{ width: 1310, marginRight: 2, my: 5 }}>       
            <Skeleton animation="wave" variant="rectangular" width={1310} height={300} />    
          </Box>
        </GridItem>
      </GridContainer>
    );
}

